import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

/**
 * Auth wall — everything inside this wrapper requires a signed-in account.
 * Unauthenticated visitors are sent to /welcome with a `next` param so they
 * land where they were trying to go after signing in.
 */
export default function RequireAuth({ children }) {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return <div className="p-12 text-center text-muted-foreground">Loading…</div>;
    }

    if (!user) {
        const pin = location.pathname.match(/^\/listing\/([^/]+)/);
        if (pin) return <Navigate to={`/p/${pin[1]}`} replace />;
        const next = encodeURIComponent(location.pathname + location.search);
        return <Navigate to={`/welcome?next=${next}`} replace />;
    }

    return children;
}
